import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { EventData } from '../../../models/event-data';
import { Workflow } from '../../../models/workflow';
import { IFormComponent } from '../core/form-component.interface';
import { WorkflowConditionsFormComponent } from './conditions-form/workflow-condition-form.component';

/**
 * Composants affichant le formulaire d'édition de l'évènement de workflow selectionnée dans le designer de workflow.
 */
@Component({
    selector: 'app-workflow-event-form',
    templateUrl: './workflow-event-form.html',
    styleUrl: './workflow-event-form.scss',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        FaIconComponent,
        CommonModule,
        WorkflowConditionsFormComponent,
        MatCheckboxModule,
        MatTooltipModule,
    ],
})
export class WorkflowEventFormComponent implements IFormComponent, OnInit {
    public faCircleInfo = faCircleInfo;

    /**
     * Données de l'action affichées dans le formulaire.
     */
    private _data: EventData;

    /**
     * Spécifie les données de l'évènement affichées dans le formulaire.
     */
    set data(value: EventData) {
        this._data = value;
        this.fillForm();
    }

    /**
     * Obtient les données de l'évènement affichées dans le formulaire.
     */
    get data(): EventData {
        this.fillData();
        return this._data;
    }

    /**
     * Instance du workflow.
     */
    public workflow: Workflow;

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    get isDirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Constructeur.
     * @param changeDetector : Detecteur de changement.
     */
    constructor(private changeDetector: ChangeDetectorRef) {
        console.log('WorkflowEventFormComponent - constructor : ');
    }

    /**
     * Initialise le composant.
     */
    ngOnInit() {
        this.dataForm = new UntypedFormGroup({
            id: new UntypedFormControl({
                value: '',
                disabled: true,
            }),
            isEnabled: new UntypedFormControl({ value: true }),
            conditions: new UntypedFormControl({ value: [] }),
        });

        this.fillForm();
    }

    /**
     * Remplit le formulaire avec les données de l'évènement.
     */
    private fillForm() {
        if (this._data) {
            if (this.dataForm) {
                this.dataForm.get('id').setValue(this._data.id);
                this.dataForm.get('isEnabled').setValue(this._data.isEnabled);
                this.dataForm.get('conditions').setValue(this._data.conditions);
            }
        }
    }

    /**
     * Récupère les données à partir des champs du formulaire et met à jour l'object data.
     */
    public fillData() {
        let eventData: EventData = new EventData();
        // let conditionData: BaseConditionData = null;

        // switch (this.data.condition.type) {
        //     case TempWorkflowConditionTypes.Aucune:
        //         conditionData = new DefaultConditionData();
        //         break;
        //     case TempWorkflowConditionTypes.StepCompleted:
        //         conditionData = new CompletedStepsConditionData();
        //         break;
        //     default:
        //         console.error(`Le type de condition '${this.data.condition.type}' n'est pas implémentée.`);
        //         break;
        // }
        eventData.id = this._data.id;
        eventData.isEnabled = this.dataForm.get('isEnabled').value;
        eventData.conditions = this.dataForm.get('conditions').value;
        this._data = eventData;

        this.dataForm.markAsPristine();

        console.log('Fill data', this._data);
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }
}
